import { render, staticRenderFns } from "./ModalAddUsersDepartments.vue?vue&type=template&id=10998a01&"
import script from "./ModalAddUsersDepartments.vue?vue&type=script&lang=js&"
export * from "./ModalAddUsersDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports